import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class MemberApiService {
  private api = inject(ApiService);

  getOne(id: number | string): Promise<any> {
    return this.api.get(`/member/${id}`);
  }

  upsert(json: any): Promise<any> {
    return this.api.post('/member', json);
  }

  getPayment(id: number | string): Promise<any> {
    return this.api.get(`/member/${id}/payment`);
  }

  createPayment(id: number | string, json: any): Promise<any> {
    return this.api.post(`/member/${id}/payment`, json);
  }

  getTransaction(id: number | string): Promise<any> {
    return this.api.get(`/member/${id}/transaction`);
  }

  exists(json: any): Promise<any> {
    return this.api.post('/member/exists', json);
  }

  async checkPassword(json: any): Promise<boolean> {
    try {
      const res = await firstValueFrom(this.api.postRaw<any>('/member/auth', json));
      return res?.success === true;
    } catch {
      return false;
    }
  }

  createBtPostValues(id: number | string, paymentMethod?: string): Promise<any> {
    const body: any = { memberId: id };
    if (paymentMethod !== undefined && paymentMethod !== null && paymentMethod !== '') {
      body.paymentMethod = paymentMethod;
    }
    return this.api.post('/member/bt_post_values', body);
  }

  getCounsel(memberId: number | string): Promise<any> {
    return this.api.get(`/member/${memberId}/counsel`);
  }
}
